export default __webpack_public_path__ + "static/6-c7de157d9b01ae825b8b4916e62249f2.png";